// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20.6645 5.84747L12.0003 0.845215L3.33759 5.84666L11.9995 10.8458L20.6645 5.84747ZM13.001 3.93V7.93H11.001V3.93H13.001Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.6606 7.58178L12.9993 12.5779V22.5779L21.6606 17.5773V7.58178ZM16.0256 13.169L19.4897 15.169L18.4897 16.901L15.0256 14.901L16.0256 13.169Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.9993 22.5767V12.5778L2.34009 7.58015V17.5773L10.9993 22.5767ZM8.97618 14.901L5.51207 16.901L4.51207 15.169L7.97618 13.169L8.97618 14.901Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-3d-filled')
export default class Chart3DFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-3d-filled',
    }
  }
}
